import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const isMobileAppPath = (pathname: string) =>
  pathname === "/mobile" || pathname.startsWith("/mobile/");

/** App identity is available at login; installation belongs to the private flow. */
export function MobileAppMetadata() {
  const { pathname } = useLocation();
  const mobile = isMobileAppPath(pathname);
  useEffect(() => {
    if (!mobile) return;
    const previousTitle = document.title;
    const theme = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]',
    );
    const previousTheme = theme?.content;

    const icon = document.createElement("link");
    icon.rel = "icon";
    icon.type = "image/png";
    icon.sizes.value = "512x512";
    icon.href = "/app-cem-512.png";
    const touchIcon = document.createElement("link");
    touchIcon.rel = "apple-touch-icon";
    touchIcon.sizes.value = "192x192";
    touchIcon.href = "/app-cem-192.png";
    document.head.append(icon, touchIcon);
    document.title = "App CEM";
    if (theme) theme.content = "#164e63";
    return () => {
      icon.remove();
      touchIcon.remove();
      document.title = previousTitle;
      if (theme && previousTheme !== undefined) theme.content = previousTheme;
    };
  }, [mobile]);
  return null;
}
